import request, { type Agent } from 'superagent';

export class HttpRepository {
  http: Agent | null = null;
  request: Request;

  constructor(http: Agent) {
    this.http = http;
  }

  head(url: string) {
    return request.head(url);
  }
}
